<template>
  <v-container fluid>
    <PageTitle>
      <v-icon left>
        fab fa-fw fa-slideshare
      </v-icon>
      My Custom Presentations
      <template v-slot:buttons>
        <v-btn :to="{name: `${$root.routePrefix}.slide_deck.create`}"
               color="primary">
          New Presentation
        </v-btn>
      </template>
    </PageTitle>

    <v-row>
      <v-col cols="12"
             md="4"
             lg="3">
        <v-form @submit.prevent="searchDecks">
          <v-card class="mb-4">
            <v-card-title>
              Search
            </v-card-title>
            <v-card-text>
              <v-text-field v-model="form.name"
                            label="Deck Name"
                            outlined
                            dense
                            clearable>
              </v-text-field>

              <v-autocomplete v-model="form.source_id"
                              label="Has slides from"
                              :items="sourcePresentations"
                              item-value="id"
                              item-text="name"
                              outlined
                              dense
                              clearable>
              </v-autocomplete>

              <v-select v-model="form.status"
                        label="Status"
                        :items="statusCodes"
                        item-value="id"
                        item-text="name"
                        outlined
                        dense>
              </v-select>
            </v-card-text>
            <v-card-actions class="px-4">
              <v-btn type="submit"
                     color="primary">
                Search
              </v-btn>
              <v-btn @click.prevent="resetForm">
                Reset
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-form>
      </v-col>
      <v-col cols="12"
             md="8"
             lg="9">

        <v-card v-for="deck in decks"
                :key="deck.id"
                class="mb-4">
          <v-card-title>
            {{ deck.name }}
          </v-card-title>
          <v-card-text>
            <v-row>
              <v-col cols="12"
                     md="4"
                     lg="4">
                <SlideDeckThumbnail :deck="deck">
                </SlideDeckThumbnail>
              </v-col>
              <v-col cols="12"
                     md="8"
                     lg="8">
                <div>
                  Status: {{ deck.status.toUpperCase() }}
                </div>
                <div>
                  Slides: {{ deck.activePresentationSlides?.length }}
                </div>
                <div>
                  Created: {{ deck.created_at | datetime('YYYY-MM-DD') }}
                </div>
              </v-col>
            </v-row>
          </v-card-text>
          <v-card-actions class="px-4">
            <v-menu offset-y>
              <template v-slot:activator="{ on }">
                <v-btn :disabled="deck.is_active === false"
                       v-on="on">
                  Open
                  <v-icon right>
                    fas fa-fw fa-chevron-down
                  </v-icon>
                </v-btn>
              </template>
              <OpenPresentationMenuList :presentation="deck">
              </OpenPresentationMenuList>
            </v-menu>

            <v-btn :to="{name: `${$root.routePrefix}.slide_deck.create`, query: {source_deck_id: deck.id}}"
                   class="ml-2">
              New Presentation
            </v-btn>

          </v-card-actions>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import PageTitle from "../../components/PageTitle.vue";
import {Form} from 'vform';
import slideDeckService from '../../services/slideDeckService';
import {mapGetters} from 'vuex';
import store from '../../store';
import SlideDeckThumbnail from './components/SlideDeckThumbnail.vue';
import OpenPresentationMenuList from '../content/components/OpenPresentationMenuList.vue';

export default {
  components: {
    OpenPresentationMenuList,
    SlideDeckThumbnail,
    PageTitle,
  },
  data() {
    return {
      busy: false,
      decks: [],
      form: new Form({
        name: '',
        owner_id: store.getters.user.id,
        status: 'Active',
        source_id: '',
      }),
      statusCodes: [
        {id: '', name: 'Any status'},
        {id: 'Active', name: 'Active'},
        {id: 'Inactive', name: 'Inactive'},
      ]
    }
  },
  computed: {
    ...mapGetters([
      'activeUsers',
      'user',
    ]),
    ...mapGetters('content', [
      'presentations',
    ]),
    sourcePresentations() {
      return this.presentations.filter(p => p.settings.can_be_used_in_builder && p.is_slide_deck === false)
    },
  },
  created() {
    this.fetchData();
  },
  methods: {
    fetchData() {
      this.fetchUsers();
      this.searchDecks();
    },
    fetchUsers() {
      this.$store.dispatch('fetchUsers');
    },
    searchDecks() {
      if (this.form.busy) {
        return;
      }
      slideDeckService.getSlideDecksForCurrentUser(this.form)
        .then(data => {
          this.decks = data;
        })
        .finally(() => {
          this.form.busy = false;
        })
    },
    resetForm() {
      this.form.reset();
      this.searchDecks();
    }
  }
}
</script>
